import {
  ReactElement,
  useReducer,
  createContext,
  useContext,
  Dispatch,
} from "react";

import produce from "immer";

import { ApiError } from "api_clients/api_error";

type State = ApiError | null;

type Action = {
  type: "error:apiError";
  payload: { error: ApiError };
};

interface Context {
  state: State;
  dispatch: Dispatch<Action>;
}

export const ErrorContext = createContext<Context>({} as Context);

export const useErrorContext = (): Context => useContext(ErrorContext);

const reducer = produce((state: State, action: Action): State | null => {
  switch (action.type) {
    case "error:apiError": {
      // eslint-disable-next-line no-param-reassign
      state = action.payload.error;
      return state;
    }
    default: {
      const unreachable: never = action.type;
      throw new Error(unreachable);
    }
  }
});

export function ErrorContextProvider({
  children,
}: {
  children: ReactElement;
}): ReactElement {
  const [state, dispatch] = useReducer<typeof reducer>(reducer, null);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ErrorContext.Provider value={{ state, dispatch }}>
      {children}
    </ErrorContext.Provider>
  );
}
